import type { SecuritySettingsFeatureConfig } from '../type';

export const securitySettingsConfig: Partial<SecuritySettingsFeatureConfig> = {
    oidc: true,
    externalClientId: 'ssp',
    alternateExternalClientId: 'urn:cz:csas:mep:proxyAppSso',
    externalTargets: ['alias', 'limits', 'methods'],
    targetTranslationMap: {
        alias: 'user',
        limits: 'set_limit',
    },
};
